
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { DocumentValidityModel, MinimalDocumentModel } from "@/api-client";

@Component
export default class MinimalMedicalCertificate extends Vue {
    @Prop({ required: true })
    document!: DocumentValidityModel;
}
